var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 10.5817 0.166169 10.1805 0.461953 9.88475C0.757737 9.58896 1.15891 9.42279 1.57721 9.42279H8.92279V2.07721C8.92279 1.65891 9.08896 1.25774 9.38475 0.961953C9.68053 0.666169 10.0817 0.5 10.5 0.5C10.9183 0.5 11.3195 0.666169 11.6153 0.961953C11.911 1.25774 12.0772 1.65891 12.0772 2.07721V9.42279H19.4228C19.8411 9.42279 20.2423 9.58896 20.538 9.88475C20.8338 10.1805 21 10.5817 21 11C21 11.4183 20.8338 11.8195 20.538 12.1153C20.2423 12.411 19.8411 12.5772 19.4228 12.5772H12.0772V19.9228C12.0772 20.3411 11.911 20.7423 11.6153 21.038C11.3195 21.3338 10.9183 21.5 10.5 21.5C10.0817 21.5 9.68053 21.3338 9.38475 21.038C9.08896 20.7423 8.92279 20.3411 8.92279 19.9228V12.5772H1.57721C1.15891 12.5772 0.757737 12.411 0.461953 12.1153C0.166169 11.8195 0 11.4183 0 11Z",
    fill: "#7269EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9fc05aff0cfac11f8914ebdf36206212.svg";
export { ForwardRef as ReactComponent };